import React, { useEffect, useState } from 'react';
import { makeStyles } from "@material-ui/core/styles";
import { Avatar, Box, Grid, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import AppButton from "../../../components/CustomButtons/AppButton";
import { ArrowBackIos } from "@material-ui/icons";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { useDispatch, useSelector } from "react-redux";
import { showToast } from "../../../store/slices/toast";
import { Rating } from "@material-ui/lab";
import AppColor from "../../../utilities/AppColor";
import classNames from "classnames";
import SearchWorkerMap from "./components/SearchWorkerMap";
import moment from 'moment';
import BookingForm from "./components/BookingForm";
import { fetchAccreditation, fetchWorkerDetail } from "../../../store/slices/worker";
import Loading from "../../../components/Common/Loading";
import AppConfig, { SYSTEM_ROLE, WORKER_TYPE } from "../../../config/AppConfig";
import AppUtil from "../../../utilities/AppUtil";
import { getAuthInfo } from "../../../store/slices/auth";

const useStyles = makeStyles(() => ({
    headerContainer: {
        backgroundColor: AppColor.darkBlue,
    },
    imageMobile: {
        width: '140px',
        height: '140px',
        borderRadius: `${140 / 2}px`,
        objectFit: 'cover'
    },
    image: {
        width: '270px',
        height: '270px',
        borderRadius: `${270 / 2}px`,
        objectFit: 'cover'
    },
    title: {
        fontSize: '45px',
        color: 'white'
    },
    points: {
        fontSize: '16px',
        color: 'white',
        marginLeft: '10px'
    },
    specialty: {
        fontSize: '16px',
        fontWeight: 'bold',
        color: 'white',
        marginBottom: '10px'
    },
    commonText: {
        fontSize: '16px',
        color: 'white',
        marginBottom: '10px'
    },
    descriptionContainer: {
        backgroundColor: AppColor.descriptionBg
    },
    descriptionTitle: {
        color: AppColor.darkPurple,
        fontSize: '25px'
    },
    description: {
        fontSize: '15px',
        color: AppColor.darkPurple,
        lineHeight: '18px',
        wordBreak: "break-word"
    },
    commonTitle: {
        fontSize: '25px',
        color: AppColor.darkPurple,
        fontWeight: 'normal',
        marginBottom: '15px'
    },
    checkContainer: {
        borderBottom: `1px solid rgba(0,0,0,0.2)`,
        paddingTop: '12px',
        paddingBottom: '12px'
    },
    checkLabel: {
        fontSize: '13px',
        color: AppColor.darkPurple,
        fontWeight: 'bold',
    },
    checkSubLabel: {
        fontSize: '13px',
        color: 'rgba(0, 0, 0, 0.5)',
        fontWeight: 'normal',
        marginTop: '5px'
    },
    marginLeft: {
        marginLeft: '10px'
    },
    specialtyLabel: {
        fontSize: '15px',
        color: AppColor.darkPurple,
        fontWeight: 'normal',
    },
    subTitle: {
        fontSize: '15px',
        color: 'rgba(0, 0, 0, 0.5)',
        fontWeight: 'normal'
    },
    qualificationItem: {
        fontSize: '15px',
        color: 'rgba(0, 0, 0, 0.7)',
        fontWeight: 'normal'
    },
    rating: {
        color: AppColor.mainColor
    }
}))

const SearchWorkerDetail = () => {
    const classes = useStyles();
    const { t } = useTranslation();
    const history = useHistory();
    const location = useLocation();
    const isMobile = AppUtil.mobileAndTabletCheck();
    const dispatch = useDispatch();
    const { id } = useParams();
    const [data, setData] = useState({});
    const [loading, setLoading] = useState(true);
    const [accreditation, setAccreditation] = useState();
    const user = useSelector(getAuthInfo);
    const _getLink = () => {
        dispatch(showToast({
            type: 'success',
            message: t('label.copied_to_clipboard')
        }))
    }
    const _loadData = async () => {
        const { payload } = await dispatch(fetchWorkerDetail({ workerId: id }))
        if (payload) {
            setData(payload);
        }
        return payload;
    }
    const _loadAccreditations = (data) => {
        dispatch(fetchAccreditation({}))
            .then(({ payload }) => {
                if (payload) {
                    const accreditation = payload.find(e => e.id === data.accreditationId);
                    setAccreditation(accreditation);
                }
            })
    }
    useEffect(() => {
        _loadData().then((data) => {
            setLoading(false)
            _loadAccreditations(data);
        });
    }, []);
    if (loading) {
        return <Loading />;
    }
    console.log('data ', data);
    return (
        <Box>
            <Box className={classes.headerContainer} p={isMobile ? 1 : 3}>
                {!isMobile && <Box>
                    {
                        user && (
                            <AppButton style={{ 'float': 'left' }}
                                label={t('button.back')}
                                buttonColor={'transparent'}
                                startIcon={<ArrowBackIos />}
                                disableElevation
                                onClick={() => history.push('/admin/search-worker', {
                                    isKeep: true
                                })}
                            />
                        )
                    }
                    <CopyToClipboard style={{ 'float': 'right' }}
                        text={window.location.origin.concat(`/public/worker-profile/${id}`)}
                        onCopy={_getLink}
                    >
                        <AppButton
                            label={t('button.get_link')}
                            buttonColor={AppColor.pink}
                        />
                    </CopyToClipboard>
                </Box>}
                <Box my={3}>
                    <Grid container spacing={3} justifyContent='center'>
                        <Grid item sm={12} md={4}>
                            <Box display="flex" justifyContent="center">
                                {data.avatarAws3Link ? (
                                    <img src={data.avatarAws3Link} className={isMobile ? classes.imageMobile : classes.image} alt="Avatar" />
                                ) : (
                                    <Avatar style={{ width: '270px', height: '270px' }} />
                                )}
                            </Box>
                        </Grid>
                        <Grid item sm={12} md={8}>
                            <Box display="flex" alignItems="center" flexWrap={isMobile ? "wrap" : "nowrap"}>
                                <Box mr={5}>
                                    <Typography variant="h5" className={classes.title}>
                                        {data.firstName} {data.lastName}
                                    </Typography>
                                </Box>
                                <Box display="flex" alignItems="center">
                                    <Rating
                                        name="read-only"
                                        value={data.rating}
                                        precision={0.5}
                                        className={classes.rating}
                                        readOnly
                                    />
                                    <Typography variant="body1" className={classes.points} noWrap>
                                        {data.point || 0} {t('label.point', { count: data.point })}
                                    </Typography>
                                </Box>
                            </Box>
                            <Box mt={3}>
                                {accreditation && (
                                    <Typography variant="body1" className={classes.specialty}>
                                        {accreditation.name}
                                    </Typography>
                                )}
                                <Typography variant="body1" className={classes.specialty} noWrap>
                                    {
                                        data.workerType === WORKER_TYPE.NURSE
                                            ? data.specialties && data.specialties.map(sp => sp.name).join(', ')
                                            : data.supports && data.supports.map(sp => sp.name).join(', ')
                                    }
                                </Typography>
                            </Box>
                            <Box mt={2}>
                                <Typography variant="body1" className={classes.commonText}>
                                    {t('label.member_since')}: {AppUtil.formatDate(data.createDate, AppConfig.DATE_FORMAT.DEFAULT)}
                                </Typography>
                                <Typography variant="body1" className={classes.commonText}>
                                    {t('label.gender')}: {t(`label.${data.gender}`.toLowerCase())}
                                </Typography>
                                <Typography variant="body1" className={classes.commonText}>
                                    {t('label.age')}: {moment().diff(moment(data.dateOfBirth, 'YYYY/MM/DD'), 'years')}
                                </Typography>
                                <Typography variant="body1" className={classes.commonText}>
                                    {t('label.work_experience')}: {data.yearsOfExperience}
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Box>
            <Box className={classes.descriptionContainer} p={isMobile ? 1 : 5}>
                <Grid container spacing={isMobile ? 2 : 5} direction="column">
                    <Grid item sm={12} md={4}>
                        <Box display="flex" justifyContent="center" flexDirection={'column'} className="h-100">
                            <Typography variant="h5" className={classes.descriptionTitle}>
                                {t('label.about')} {data.firstName} {data.lastName}
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item sm={12} md={8}>
                        <Typography variant="body1" className={classes.description}>
                            {data.description}
                        </Typography>
                    </Grid>
                </Grid>
            </Box>
            <Box p={isMobile ? 0 : 5} className="bg-white">
                <Grid container spacing={isMobile ? 1 : 5}>
                    <Grid item sm={12} md={6}>
                        <Typography variant="h5" className={classes.commonTitle}>
                            {t('title.care_aid_verified')}
                        </Typography>
                        <Typography variant="body1" className={classes.description}>
                            {t('text.ensure_worker')}
                        </Typography>
                        <Box my={3}>
                            {data.workerType === WORKER_TYPE.NURSE && data.aphraRegistrationNumber && (
                                <Box display="flex" alignItems="center" className={classes.checkContainer}>
                                    <img src={require('../../../assets/img/ndis.png')} alt="NDIS" />
                                    <Typography variant="h5" className={classNames([classes.checkLabel, classes.marginLeft])}>
                                        {t('label.ndis_registered')}
                                    </Typography>
                                </Box>
                            )}
                            {data.workerType === WORKER_TYPE.SUPPORT_WORKER && data.workingWithChildrenDoc && (
                                <Box display="flex" alignItems="center" className={classes.checkContainer}>
                                    <img src={require('../../../assets/img/ndis.png')} alt="NDIS" />
                                    <Typography variant="h5" className={classNames([classes.checkLabel, classes.marginLeft])}>
                                        {t('label.work_with_children')}
                                    </Typography>
                                </Box>
                            )}
                            {data.policeCheckDoc && (
                                <Box display="flex" alignItems="center" className={classes.checkContainer}>
                                    <img src={require('../../../assets/img/police-check.png')} alt="Police Check" />
                                    <Typography variant="h5" className={classNames([classes.checkLabel, classes.marginLeft])}>
                                        {t('label.police_check')}
                                    </Typography>
                                </Box>
                            )}
                            {data.certificationDoc && (
                                <Box display="flex" alignItems="center" className={classNames([classes.checkContainer, 'border-0'])}>
                                    <img src={require('../../../assets/img/user-check.png')} alt="References Checked" />
                                    <Typography variant="h5" className={classNames([classes.checkLabel, classes.marginLeft])}>
                                        {t('label.references_checked')}
                                    </Typography>
                                </Box>
                            )}
                        </Box>
                        <Typography variant="h5" className={classes.commonTitle}>
                            {user.role === SYSTEM_ROLE.HOSPITAL_ADMIN || user.role === SYSTEM_ROLE.HOSPITAL_OTHER ? t('title.specialty_offered') : t('title.supports_offered')}
                        </Typography>
                        <Box my={3}>
                            {(user.role === SYSTEM_ROLE.HOSPITAL_ADMIN || user.role === SYSTEM_ROLE.HOSPITAL_OTHER) && data.specialties && data.specialties.map((specialty, index) => (
                                <Box key={index} className={classNames([classes.checkContainer, `${index === data.specialties.length - 1 ? 'border-0' : ''}`])}>
                                    <Typography variant="h5" className={classNames([classes.specialtyLabel])}>
                                        {specialty.name}
                                    </Typography>
                                </Box>
                            ))}
                            {user.role !== SYSTEM_ROLE.HOSPITAL_ADMIN && user.role !== SYSTEM_ROLE.HOSPITAL_OTHER && data.supports && data.supports.map((support, index) => (
                                <Box key={index} className={classNames([classes.checkContainer, `${index === data.supports.length - 1 ? 'border-0' : ''}`])}>
                                    <Typography variant="h5" className={classNames([classes.specialtyLabel])}>
                                        {support.name}
                                    </Typography>
                                </Box>
                            ))}
                        </Box>
                        <Typography variant="h5" className={classes.commonTitle}>
                            {t('label.languages')}
                        </Typography>
                        <Box mb={3}>
                            {data.languages.map((lang, index) => (
                                <Box key={index} mb={2}>
                                    <Typography variant="body1" className={classNames([classes.qualificationItem])}>
                                        {lang.language}
                                    </Typography>
                                </Box>
                            ))}
                        </Box>
                    </Grid>
                    <Grid item sm={12} md={12} xs={12}>
                        <Typography variant="h5" className={classes.commonTitle}>
                            {t('title.qualifications')}
                        </Typography>
                        <Typography variant="h5" className={classes.subTitle}>
                            {t('label.verified_by_care_aid')}
                        </Typography>
                        <Box my={3}>
                            <Box display="flex" alignItems="center">
                                <img src={require('../../../assets/img/checked.png')} alt="Nurse Practitioner" />
                                <Typography variant="h5" className={classNames([classes.qualificationItem, classes.marginLeft])}>
                                    {accreditation?.name}
                                </Typography>
                            </Box>
                        </Box>
                        <Typography variant="h5" className={classes.commonTitle}>
                            {t('title.work_locations')}
                        </Typography>
                        <Box mb={3}>
                            <SearchWorkerMap
                                lat={data.lat}
                                lng={data.lng}
                                zoom={15}
                            />
                        </Box>
                    </Grid>
                </Grid>
                {user.approvalStatus === 'ACTIVE' && !location.pathname?.includes('worker-profile') && (
                    <Box mt={5}>
                        <BookingForm
                            data={data}
                        />
                    </Box>
                )}
            </Box>
        </Box>
    )
}

export default SearchWorkerDetail;
